import React from 'react';
import classnames from 'classnames';

import AlvotechBasket from 'components/assets/user-icons/Alvotech_basket.svg';
import AlvotechBiosimilar from 'components/assets/user-icons/Alvotech_biosimilar2.svg';
import AlvotechCosmetics from 'components/assets/user-icons/Alvotech_cosmetics.svg';
import AlvotechEmploeeys from 'components/assets/user-icons/Alvotech_emploeeys.svg';
import AlvotechGenericProjects from 'components/assets/user-icons/Alvotech_generic-projects.svg';
import AlvotechGreen from 'components/assets/user-icons/Alvotech_green.svg';
import AlvotechHandPill from 'components/assets/user-icons/Alvotech_hand-pill.svg';
import AlvotechKeyGrowth from 'components/assets/user-icons/Alvotech_key-growth copy.svg';
import AlvotechManufacturinCenters from 'components/assets/user-icons/Alvotech_manufacturin-centers.svg';
import AlvotechMap from 'components/assets/user-icons/Alvotech_map.svg';
import AlvotechMedical from 'components/assets/user-icons/Alvotech_medical.svg';
import AlvotechMicroscope from 'components/assets/user-icons/Alvotech_microscope.svg';
import AlvotechMolecule from 'components/assets/user-icons/Alvotech_molecule.svg';
import AlvotechNetwork from 'components/assets/user-icons/Alvotech_network.svg';
import AlvotechPipeline from 'components/assets/user-icons/Alvotech_pipeline2.svg';
import AlvotechPlayground from 'components/assets/user-icons/Alvotech_playground.svg';
import AlvotechAward from 'components/assets/user-icons/Alvotech_award.svg';
import AlvotechBiosGenerics from 'components/assets/user-icons/Alvotech_bios-generics.svg';
import AlvotechCapacity from 'components/assets/user-icons/Alvotech_capacity.svg';
import AlvotechCompany from 'components/assets/user-icons/Alvotech_company.svg';
import AlvotechDna from 'components/assets/user-icons/Alvotech_dna.svg';
import AlvotechInvestment from 'components/assets/user-icons/Alvotech_investment.svg';
import AlvotechManufacturing from 'components/assets/user-icons/Alvotech_manufacturing.svg';
import AlvotechPeople from 'components/assets/user-icons/Alvotech_people.svg';
import AlvotechPills from 'components/assets/user-icons/Alvotech_pills.svg';
import AlvotechProfessional from 'components/assets/user-icons/Alvotech_professional.svg';
import AlvotechSquareMeter from 'components/assets/user-icons/Alvotech_square-meter.svg';

import s from './ColumnSection.module.scss';

type Props = {
  color?: 'brand' | 'white' | 'dark' | string;
};

export const ColumnSectionIcons = ({ color }: Props) => {
  return (
    <div className={classnames(s.icons, s[color as string])}>
      <div className={s.icons__background}>
        <div className={s.icons__container}>
          <div className={s.icons__list}>
            <div className={s.icons__item}>
              <AlvotechBasket />
              <div className={s.icons__name}>Basket</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechBiosimilar />
              <div className={s.icons__name}>Biosimilar</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechCosmetics />
              <div className={s.icons__name}>Cosmetics</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechEmploeeys />
              <div className={s.icons__name}>Emploeeys</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechGenericProjects />
              <div className={s.icons__name}>Generic Projects</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechGreen />
              <div className={s.icons__name}>Green</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechHandPill />
              <div className={s.icons__name}>Hand Pill</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechKeyGrowth />
              <div className={s.icons__name}>Key Growth</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechManufacturinCenters />
              <div className={s.icons__name}>Manufacturin Centers</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechMap />
              <div className={s.icons__name}>Map</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechMedical />
              <div className={s.icons__name}>Medical</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechMicroscope />
              <div className={s.icons__name}>Microscope</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechMolecule />
              <div className={s.icons__name}>Molecule</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechNetwork />
              <div className={s.icons__name}>Network</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechPipeline />
              <div className={s.icons__name}>Pipeline</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechPlayground />
              <div className={s.icons__name}>Playground</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechAward />
              <div className={s.icons__name}>Award</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechBiosGenerics />
              <div className={s.icons__name}>Bios Generics</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechCapacity />
              <div className={s.icons__name}>Capacity</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechCompany />
              <div className={s.icons__name}>Company</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechDna />
              <div className={s.icons__name}>DNA</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechInvestment />
              <div className={s.icons__name}>Investment</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechManufacturing />
              <div className={s.icons__name}>Manufacturing</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechPeople />
              <div className={s.icons__name}>People</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechPills />
              <div className={s.icons__name}>Pills</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechProfessional />
              <div className={s.icons__name}>Professional</div>
            </div>
            <div className={s.icons__item}>
              <AlvotechSquareMeter />
              <div className={s.icons__name}>Square Meter</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
